<template>
  <div class="calendar-months">
    <span v-for="month in months" :key="month.nr" class="calendar-months--month" :class="month.selected? 'selected' : ''" @click="selectMonth(month.nr)">
      {{month.name}}
    </span>
  </div>
</template>
<script>
export default {
  name: 'CalendarMonthsView',
  props: {
    viewedMonth: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      monthNames: [ {nr:1, name: 'Jan'}, 
      { nr:2, name: 'Feb'}, 
      { nr:3, name: 'Mar'}, 
      { nr:4, name: 'Apr'}, 
      { nr:5, name: 'May'}, 
      { nr:6, name: 'Jun'}, 
      { nr:7, name: 'Jul'}, 
      { nr:8, name: 'Aug'}, 
      { nr:9, name: 'Sep'}, 
      { nr:10, name: 'Oct'}, 
      { nr:11, name: 'Nov'}, 
      { nr:12, name: 'Dec'} ]
    }
  },
  computed: {
    months() {
      let tmpMonths = []
      this.monthNames.reduce((t, o)=>{
        let tmp = o
        if (this.viewedMonth == o.nr) tmp.selected = true
        else tmp.selected = false
        tmpMonths.push(tmp) 
      }, this.monthNames[0])
      return tmpMonths
    }
  },
  methods: {
    selectMonth(id) {
      this.$emit('selectMonth', id)
    }
  }
}
</script>
<style lang="scss" scoped>
.calendar-months {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  &--month {
    cursor: pointer;
    &.selected {
      color:$bh-blue--2;
      font-weight: bold;
    }
  }
}
</style>